module.exports = __webpack_public_path__ + "img/mo_super02.ec98273c.png";